
import { CheckCircleRounded, RestoreRounded, ErrorRounded } from '@mui/icons-material';
import { Chip } from '@mui/material';

interface IStatusCell {
    statusCode: 1 | 2 | 3;
  }

const statusMap = {
	1: {
		name: "Pending",
		backgroundColor: '#ffedcc',
		borderColor: '#fce0ad',
		icon: <RestoreRounded sx={{ color: '#f7a308 !important'}} />
	},
	2: {
		name: "Success",
		backgroundColor: '#dbf7e2',
		borderColor: '#b6eec4',
		icon: <CheckCircleRounded sx={{ color: '#23cf4e !important'}} />
	},
	3: {
		name: "Failed",
		backgroundColor: '#FFDDDB',
		borderColor: '#FFCBC8',
		icon: <ErrorRounded sx={{ color: '#F04E43 !important'}} />
	}
}

export const StatusCell: React.FC<IStatusCell> = ({ statusCode }) => {
	if (!statusCode) return <div />
	const { icon, name, borderColor, backgroundColor } = statusMap[statusCode];
	return (
		<Chip
			icon={icon}
			label={name}
			size='small'
			sx={{ borderColor, backgroundColor, borderRadius: 100 }}
		/>
	)
}